"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Privacy() {
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: bodyRef,
    isVisible: bodyVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const paragraphs = [{
    key: "Privacy Policy sub hed",
    content: <>
          At Lakeland Bathroom Remodel Pros, we collect the information you choose to provide when you call us, submit a form, or request a quote. This may include your name, phone number, email address, and any project details you submit.{" "}
  
        </>,
    sizeClass: "text-[1.0625rem] md:text-[1.25rem] leading-[1.55]"
  }];
  return <section data-section-id="6954" id="privacy-terms" className="bg-background py-32 md:py-44 text-foreground">
      <div className="mx-auto max-w-[1440px] px-6 sm:px-10 md:px-16 lg:px-24 xl:px-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          {}
          <div ref={headingRef} className={`lg:col-span-5 transition-all duration-[800ms] ease-[cubic-bezier(0.22,1,0.36,1)] ${headingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <p className="font-mono uppercase tracking-widest text-muted-foreground text-[0.9375rem] leading-[1.45]">
              Legal Policy
            </p>
            <h1 className="font-default mt-6 text-foreground font-semibold" style={{
            fontSize: "clamp(2rem, 4.2vw, 3.5rem)",
            lineHeight: 1.08,
            letterSpacing: "-0.018em"
          }}>Privacy Policy</h1>
          </div>

          {}
          <div ref={bodyRef} className="lg:col-span-7">
            <div className="max-w-[58ch] !h-[123.73px]">
              {paragraphs.map((p, i) => <p data-index={i} key={p.key} className={`font-default text-foreground/85 ${p.sizeClass} ${i > 0 ? "mt-7" : ""} transition-all ease-[cubic-bezier(0.22,1,0.36,1)] ${bodyVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
              transitionDuration: "800ms",
              transitionDelay: bodyVisible ? `${i * 100}ms` : "0ms",
              letterSpacing: "-0.005em"
            }}>
                  {p.content}
                </p>)}

              <p className={`font-serif italic text-muted-foreground text-[0.9375rem] leading-[1.45] mt-12 transition-all ease-[cubic-bezier(0.22,1,0.36,1)] ${bodyVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
              transitionDuration: "800ms",
              transitionDelay: bodyVisible ? `${paragraphs.length * 100}ms` : "0ms"
            }}>Effective immediately.</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}